module.exports = __webpack_public_path__ + "img/hero8.3bd01f22.png";